module.exports = __webpack_public_path__ + "static/media/review-img3.f3443e72.png";